import { unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-367ccc0b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "main-container"
};
const _hoisted_2 = {
  class: "fixed-header"
};
import Navbar from './components/Navbar';
import Sidebar from './components/SideBar';
import AppMain from './components/AppMain';
import TagsView from '@/components/TagsView';
export default {
  __name: 'index',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["app-wrapper", [_ctx.$store.getters.sidebarOpened ? 'openSidebar' : 'hideSidebar']])
      }, [_createVNode(_unref(Sidebar), {
        id: "guide-sidebar",
        class: "sidebar-container",
        style: _normalizeStyle({
          backgroundColor: _ctx.$store.getters.cssVar.menuBg
        })
      }, null, 8, ["style"]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(Navbar)), _createVNode(_unref(TagsView), {
        id: "guide-tags"
      })]), _createVNode(_unref(AppMain))])], 2);
    };
  }
};